export default "__VITE_ASSET__DSI03eO5__"